module.exports = __webpack_public_path__ + "lato-black-webfont.0df4fefd11ec391afecc.eot";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/lato-black-webfont.eot
// module id = ../../../../../resources/layout/fonts/lato-black-webfont.eot
// module chunks = styles